// Полоса «готова новая версия» под всем интерфейсом.
//
// Она внизу, а не сверху, и это не симметрия ради симметрии. Наверху стоит полоса «демо» —
// свойство всего сеанса, которое человек обязан увидеть до того, как поверит числам на экране.
// Обновление же новость служебная: важная нам, необязательная ему прямо сейчас. Всё, что
// требует внимания немедленно, живёт наверху; всё, что подождёт, — внизу.
//
// Полоса появляется ТОЛЬКО когда файл уже скачан. Пока он едет, показывать нечего: человек
// ничего не просил, и «идёт загрузка обновления» посреди закрытия ведомости — это шум.
//
// Она не перекрывает содержимое и не модальная. Программа при установке перезапускается, и
// отобрать окно у человека, который стоит в середине незакрытой формы, нельзя ни при каких
// условиях — поэтому нажатие всегда его.
//
// Пока открыто окно «Что нового» с той же кнопкой «Обновить», полосы нет: два одинаковых
// действия рядом человек читает как два разных и ищет между ними разницу.

import { useEffect, useState } from 'react';

import {
  useОбновление,
  открытьМагазин,
  следитьЗаОбновлениями,
  установитьОбновление,
} from '@/shared/desktop/обновление';
import * as Button from '@/shared/ui/button';

import { useОкноОбновленияОткрыто } from './ЧтоНового';

export function ПлашкаОбновления() {
  const этап = useОбновление((состояние) => состояние.этап);
  const версия = useОбновление((состояние) => состояние.версия);
  const отложеноДо = useОбновление((состояние) => состояние.отложеноДо);
  const отложить = useОбновление((состояние) => состояние.отложить);
  const окноОткрыто = useОкноОбновленияОткрыто((состояние) => состояние.открыто);

  // Слежение заводится один раз на весь сеанс и живёт столько же, сколько защищённая область.
  // В браузере оно само ничего не делает: проверка внутри знает, что окна программы нет.
  useEffect(() => следитьЗаОбновлениями(), []);

  // Отсрочка не может истечь сама по себе: состояние меняется только при действии человека.
  // Поэтому по её окончании будим компонент таймером, иначе полоса вернулась бы лишь при
  // следующей перерисовке по другой причине — то есть когда придётся.
  const [, разбудить] = useState(0);
  useEffect(() => {
    const осталось = отложеноДо - Date.now();
    if (осталось <= 0) {
      return;
    }
    const таймер = setTimeout(() => разбудить((н) => н + 1), осталось);
    return () => clearTimeout(таймер);
  }, [отложеноДо]);

  if (этап === 'нет' || версия === null || Date.now() < отложеноДо || окноОткрыто) {
    return null;
  }

  const ставится = этап === 'ставится';
  // На планшете обновление ставит магазин: полоса зовёт в него, а не ставит сама.
  const вМагазине = этап === 'в-магазине';

  return (
    <div
      className='flex shrink-0 flex-wrap items-center justify-center gap-x-3 gap-y-1 border-t border-stroke-soft-200 bg-bg-white-0 px-4 py-2 text-paragraph-sm text-text-strong-950'
      // Читалка объявляет полосу один раз при появлении: это новость, а не тревога, и
      // перебивать ею то, что человек сейчас читает, нельзя.
      role='note'
    >
      <span>
        {вМагазине
          ? `Вышла новая версия «Барка Управление» ${версия}. Обновить можно в App Store, это меньше минуты: ваши данные на сервере и останутся на месте.`
          : `Готова новая версия ${версия}. Обновление займёт около полуминуты, программа откроется снова.`}
      </span>
      <div className='flex items-center gap-2'>
        <Button.Root
          type='button'
          variant='primary'
          mode='filled'
          size='xxsmall'
          className='цель-тача relative'
          disabled={ставится}
          onClick={вМагазине ? открытьМагазин : () => void установитьОбновление()}
        >
          {ставится ? 'Устанавливаю…' : 'Обновить'}
        </Button.Root>
        <Button.Root
          type='button'
          variant='neutral'
          mode='ghost'
          size='xxsmall'
          className='цель-тача relative'
          disabled={ставится}
          onClick={отложить}
        >
          Позже
        </Button.Root>
      </div>
    </div>
  );
}
